import { Map as ImmutableMap } from 'immutable';
export class RenderedArrowsRegistry {
    get asReadonly() {
        return ImmutableMap(this._registry);
    }
    constructor(registry) {
        this.set = (id, item) => this._registry.set(id, item);
        this.get = (id) => this._registry.get(id);
        this.delete = (id) => this._registry.delete(id);
        this._registry = registry !== null && registry !== void 0 ? registry : new Map();
    }
}
